import React, { useState, useEffect } from 'react';
import { AlertTriangle } from 'lucide-react';
import { registerConfirmHandler } from '../utils/confirm';

export default function ConfirmDialog() {
  const [dialog, setDialog] = useState(null);

  useEffect(() => {
    registerConfirmHandler((message, title) => {
      return new Promise((resolve) => {
        setDialog({ message, title, resolve });
      });
    });
  }, []);

  useEffect(() => {
    if (!dialog) return;
    const handler = (e) => {
      if (e.key === 'Escape') { dialog.resolve(false); setDialog(null); }
      if (e.key === 'Enter') { dialog.resolve(true); setDialog(null); }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [dialog]);

  if (!dialog) return null;

  const close = (result) => {
    dialog.resolve(result);
    setDialog(null);
  };

  return (
    <div
      style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.55)', backdropFilter: 'blur(2px)', zIndex: 8000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}
      onClick={(e) => e.target === e.currentTarget && close(false)}
    >
      <div style={{ background: '#fff', borderRadius: 14, padding: '24px 28px', maxWidth: 400, width: '100%', boxShadow: '0 24px 48px rgba(0,0,0,0.2)', border: '1px solid #e4e4e7' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
          <div style={{ width: 36, height: 36, borderRadius: '50%', background: '#fef2f2', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            <AlertTriangle size={18} style={{ color: '#dc2626' }} />
          </div>
          <h3 style={{ fontSize: 16, fontWeight: 700, color: '#09090b', margin: 0 }}>{dialog.title || 'Confirm'}</h3>
        </div>
        <p style={{ fontSize: 14, color: '#4b5563', margin: '0 0 22px', lineHeight: 1.5 }}>{dialog.message}</p>
        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
          <button
            autoFocus
            onClick={() => close(false)}
            style={{ padding: '8px 18px', border: '1px solid #e4e4e7', borderRadius: 8, background: 'transparent', cursor: 'pointer', fontSize: 13, fontWeight: 600, color: '#374151' }}
          >
            Cancel
          </button>
          <button
            onClick={() => close(true)}
            style={{ padding: '8px 18px', background: '#dc2626', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 13, fontWeight: 700 }}
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
}
